import { useCan } from "modules/settings/accessRoles";
import React, { useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import {
  Grid,
  TextField as MuiTextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Slide,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress as MuiCircularProgress,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  FilterList as FilterListIcon,
  Loop as LoopIcon,
  PowerOffSharp,
  Search as SearchIcon,
} from "@mui/icons-material";
import { spacing } from "@mui/system";
import { EditableTable } from "../../../components/EditableTable";
import { setSnackbar } from "../../snackbar/api/snackbar";
import StatusTag from "../../apl/components/StatusTag";
import {
  newDropDownField,
  newFieldLinkUrl,
  newFieldPopupModel,
  newOnFieldChangeMethod,
} from "../../../components/EditableTable";
// Redux Components
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { get as getAllPropManagers } from "../api/actions";
import { get as getAllDevelopers } from "../../developer/api/actions";
import PropertyManagerForm from "./NewForm";
import axios from "axios";

const CircularProgress = styled(MuiCircularProgress)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function PropertyManagerSearchTable(props) {
  const canEditRecords = useCan()("editRecords");
  const dispatch = useDispatch();

  const CurrentLookupTypeButton = () => {
    return (
      <IconButton>
        <SearchIcon mr={2} />
      </IconButton>
    );
  };


  const SearchBar = () => {
    return (
      <TextField
        id={"searchTarget"}
        label="Search Property Managers"
        type={"text"}
        autoFocus={true}
        placeholder={"name, number, email...."}
        onChange={handleSearchQueryInput}
        name={"searchTarget"}
        value={searchQuery}
        fullWidth
        size={"small"}
        variant={"outlined"}
        style={{ width: '100%' }}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
      />
    );
  };

  // Table Stuff:
  // Account Holder 	Address 	Meter Info 	Letter Sent Dates 	Disconnect Date 	Last Paid 	Disconnect Amt 	Account Balance
  const fieldTitles = [
    "Account Holder",
    "Status",
    "Address",
    "Phone #",
    "Billing Email",
  ];
  const fieldTypes = [
    "label",
    "label",
    "label",
    "phoneLabel",
    "label"
  ];
  const fieldNames = [
    "name",
    "pmStatus",
    "address1",
    "phone",
    "billingEmail"
  ];

  // Should open a tab to a account disconnect details page
  const onSelected = (item) => {
    window.open("/propertyManager/" + item.uuid + "/" + item.id);
  };

  // Used for form refreshing after completion
  const onUpdate = () => {
    hide();
    props.getAllPropManagers();
  };

  const [display, setDisplay] = React.useState(false);

  const show = () => {
    setDisplay(true);
  };

  const hide = () => {
    setDisplay(false);
  };

  const toggleDisplay = () => {
    const shouldDisplay = !display;
    setDisplay(shouldDisplay);
  };


  const useStyles = makeStyles({});


  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [developerPMs, setDeveloperPMs] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");

  const [visiblePMs, setVisiblePMs] = React.useState([]);

  //  property UUID (not propertyManagerId) to support unit-level property managers
  const [property, setProperty] = React.useState("");
  const [propertyManagerUuidsForProperty, setPropertyManagerUuidsForProperty] = React.useState([]);
  const [isLoadingPropertyManagers, setIsLoadingPropertyManagers] = React.useState(false);

  const handleChangePage = (page) => {
    setPage(page);
  };

  const handleSelectedPropertyChange = async (event) => {
    const selectedPropertyUuid = event.target.value;
    setProperty(selectedPropertyUuid);
    
    if (selectedPropertyUuid && selectedPropertyUuid !== "") {
      setIsLoadingPropertyManagers(true);
      try {
        const response = await axios.get(`/link/propertyManager/property?propertyUuid=${selectedPropertyUuid}`);
        if (response.data && Array.isArray(response.data)) {
          setPropertyManagerUuidsForProperty(response.data);
        } else {
          setPropertyManagerUuidsForProperty([]);
        }
      } catch (error) {
        console.error("Error fetching property managers for property:", error);
        setPropertyManagerUuidsForProperty([]);
      } finally {
        setIsLoadingPropertyManagers(false);
      }
    } else {
      setPropertyManagerUuidsForProperty([]);
      setIsLoadingPropertyManagers(false);
    }
  };

  const handleSearchQueryInput = (event) => {
    setSearchQuery(String(event.target.value));
  };

  const handleDeveloperPMsClick = () => {
    handleChangePage(0);
    setDeveloperPMs(!developerPMs);
  }

  const ShowDeveloperPMsCheckBox = () => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={developerPMs}
            onChange={handleDeveloperPMsClick}
            name="developerPMs"
            color="primary"
          />
        }
        label="Developer PMs"
      />
    );
  }


  const conditionalStyling = (item) => {
    item.pmStatus = <StatusTag type={"propertyManagerStatus"} isLoading={props.propertyManagers.isLoading} typeId={item.statusId} showTitle={false} condensed={true} />
    return {};
  };

  useEffect(() => {
    props.getAllPropManagers();
    props.getAllDevelopers()
  }, [])

  // Filtering process locally: 
  const toShow = { items: JSON.parse(JSON.stringify(props.propertyManagers.data.propertyManagersList.items)), toUpdate: [], toDelete: [] };
  // Loops through each item:
  for (var x = 0; x < toShow.items.length;) {
    // Hide missing records
    if (!toShow.items[x].name || toShow.items[x].name.includes("MISSING")) {
      toShow.items.splice(x, 1);
      continue;
    }
    
    // Filtering by Search Query
    if (searchQuery != "") {
      if (!(toShow.items[x].name != null && toShow.items[x].name.toLowerCase().includes(searchQuery.toLowerCase())) &&
        !(toShow.items[x].phone != null && toShow.items[x].phone.toLowerCase().includes(searchQuery.toLowerCase())) &&
        !(toShow.items[x].billingEmail != null && toShow.items[x].billingEmail.toLowerCase().includes(searchQuery.toLowerCase())) &&
        !(toShow.items[x].address1 != null && toShow.items[x].address1.toLowerCase().includes(searchQuery.toLowerCase()))
      ) {
        toShow.items.splice(x, 1);
        continue;
      }
    }
    // Filtering By Property - based on UNIT-LEVEL property managers, not default property manager
    if (property != "" && !isLoadingPropertyManagers) {
      if (!propertyManagerUuidsForProperty.includes(toShow.items[x].uuid)) {
        toShow.items.splice(x, 1);
        continue;
      }
    }
    // Status filtering removed - show all statuses
    if(developerPMs && toShow.items[x].developerId == null){
      toShow.items.splice(x, 1);
      continue;
    }
    // If the item is good to stay, only then should you advance as cutting an item naturally advances the cursors position.
    // Im a brick for this taking longer then it should have until i realized this was going on
    x++;
  }
  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
        <Dialog
          open={display}
          TransitionComponent={Transition}
          fullWidth={"lg"}
          maxWidth={"lg"}
          keepMounted
          onClose={hide}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            New Property Manager
          </DialogTitle>
          <DialogContent>
            <PropertyManagerForm
              onUpdate={toggleDisplay}
              oncCancel={toggleDisplay}
            />
          </DialogContent>
        </Dialog>
        {/* Full Width Search Bar */}
        <div style={{ width: '100%', marginBottom: '24px' }}>
          <SearchBar />
        </div>
        
        {/* Developer PMs Checkbox */}
        <div style={{ marginBottom: '16px' }}>
          <ShowDeveloperPMsCheckBox/>
        </div>
        
        {/* Location Dropdown - Full Width */}
        <div style={{ marginBottom: '24px', width: '100%' }}>
          <FormControl fullWidth style={{ width: '100%' }}>
            <InputLabel id="propertyToBillDropDownLabel">Location{"  "}
              {(props.apl && props.apl.isLoading) || isLoadingPropertyManagers ?
                <CircularProgress size={15} m={0} />
                : null
              }
            </InputLabel>
            {(property == "" && props.apl && props.apl.isLoading) || isLoadingPropertyManagers ?
              <Select
                labelId="propertyToBillDropDownLabel"
                id="propertyToBillDropDown"
                value={property}
                onChange={handleSelectedPropertyChange}
                fullWidth
                disabled
                style={{ width: '100%' }}>
              </Select>
              :
              <Select
                labelId="propertyToBillDropDownLabel"
                id="propertyToBillDropDown"
                value={property}
                onChange={handleSelectedPropertyChange}
                fullWidth
                disabled={isLoadingPropertyManagers}
                style={{ width: '100%' }}>
                {props.apl && props.apl.data && props.apl.data.propertyPreviews && props.apl.data.propertyPreviews.length > 0 ?
                  [
                    <MenuItem key="all" value="">All</MenuItem>,
                    ...props.apl.data.propertyPreviews.map((item, key) => {
                      return (
                        <MenuItem value={item.uuid} key={key}>{item.name}</MenuItem>
                      )
                    })
                  ]
                  :
                  [
                    <MenuItem key="none" value={-1}>No Properties Found</MenuItem>
                  ]
                }
              </Select>
            }
          </FormControl>
        </div>
        <EditableTable
          readOnly={true}
          canSave={false}
          canAddItems={canEditRecords}
          conditionalStylingMethod={conditionalStyling}
          isLoading={props.propertyManagers.isLoading || isLoadingPropertyManagers}
          newItemCreationMethod={toggleDisplay}
          handleRowClickParentMethod={onSelected}
          objectArray={toShow}
          fieldTitles={fieldTitles}
          fieldTypes={fieldTypes}
          fieldNames={fieldNames}
          customHandleChangePageEvent={handleChangePage}
        />
    </div>
  );
}
// Component accountDisconnects
PropertyManagerSearchTable.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  propertyManagers: PropTypes.object.isRequired,
  getAllPropManagers: PropTypes.func.isRequired,
  getAllDevelopers: PropTypes.func.isRequired,
};

// Component State
function State(state) {
  return {
    user: state.user,
    apl: state.apl,
    propertyManagers: state.propertyManagers,
    developers: state.developers,
  };
}
export default connect(State, { getAllPropManagers, getAllDevelopers })(
  PropertyManagerSearchTable
);
